import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { initializePromotion, setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, PromotionStatus, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { DownloadTokenAuth } from '../auth/DownloadToken';
import { RequestBudgetTokenAuth } from '../auth/RequetBudgetToken';

export default function LoadConfigurationService() {
    const { currentUnit, settings, user } = useSelector(state => state.configurator);
    const { promotionSlug, code } = useParams();
    const dispatch = useDispatch();

    return useMutation(['loadConfigurationQuery'], (payload) => {
        const loadConfigurationUrl = `${EndPoints.LoadConfigUrl}/${promotionSlug}/configuration`;

        axios
            .get(loadConfigurationUrl)
            .then((response) => {
                dispatch(initializePromotion(response.data));

                const userLoggedIn = user !== null && user.isLoggedIn;
                const endDate = response.data.settings.promotion_end_date;
                const promotionStatus = response.data.settings.promotion_status;

                if (userLoggedIn) {
                    if (promotionStatus === PromotionStatus.RequestBudgetEnded) {
                        dispatch(setSnackbarMessage(FeedbackMessages.RequestBudgetEnded));
                    } else if (endDate !== undefined && endDate.length > 0) {
                        dispatch(setSnackbarMessage(`${FeedbackMessages.RequestBudgetEndDate} ${endDate}`));
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    });
}
